const containerCls = "_086cpj0z15";
const scrollContainerCls = "_086s1whdcr6";
const inputCls = "_086i10jybe6";
const placeholderIconCls = "_086p1l9n2ty";

export { containerCls, inputCls, placeholderIconCls, scrollContainerCls };
import "./TableCellInput.style.linaria.module.css";
//# sourceMappingURL=TableCellInput.style.js.map
